



































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { Col } from '@/components/molecules/DataTable'
import {
  BibliographyRealDetailContent as RealDetailContent,
  BibliographyRealDetailContent,
  defaultBibliographyRealDetailContent
} from '@/api'
import { Prefix } from '@/types'
import { Emit } from '@/node_modules/nuxt-property-decorator'

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'radio',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '60',
    resizable: true,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル'
      }
    ]
  },
  {
    width: '40',
    resizable: true,
    items: [
      {
        name: 'displayAuthor',
        headerText: '責任表示'
      }
    ]
  },
  {
    width: 120,
    items: [
      {
        name: 'sort',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: { DataTable }
})
export default class CollectionContentTreeItemInfoTable extends ComponentVue {
  @Prop({
    type: Object,
    default: defaultBibliographyRealDetailContent()
  })
  selectedContent!: RealDetailContent

  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographyRealDetailContent[]

  @Prop({
    type: Number,
    default: 0
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  sort!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isRadio!: boolean

  get cols(): Col[] {
    return COLS.filter(value => {
      return (
        (!this.sort ? value.items[0].name !== 'sort' : true) &&
        (!this.isRadio ? value.items[0].name !== 'radio' : true)
      )
    })
  }

  isRowTop(prefix: Prefix, bibliographyId: number): boolean {
    const targetIndex: number = this.findIndexByPrefixAndBibliographyId(
      prefix,
      bibliographyId
    )
    return targetIndex <= 0
  }

  isRowBottom(prefix: Prefix, bibliographyId: number): boolean {
    const targetIndex: number = this.findIndexByPrefixAndBibliographyId(
      prefix,
      bibliographyId
    )
    return targetIndex >= this.items.length - 1 || targetIndex === -1
  }

  findIndexByPrefixAndBibliographyId(
    prefix: Prefix,
    bibliographyId: number
  ): number {
    return this.items.findIndex(
      item => item.prefix === prefix && item.bibliographyId === bibliographyId
    )
  }

  upRow(prefix: Prefix, bibliographyId: number): void {
    if (this.isRowTop(prefix, bibliographyId)) return

    const targetIndex: number = this.findIndexByPrefixAndBibliographyId(
      prefix,
      bibliographyId
    )

    this.items.splice(
      targetIndex - 1,
      2,
      this.items[targetIndex],
      this.items[targetIndex - 1]
    )
  }

  downRow(prefix: Prefix, bibliographyId: number): void {
    if (this.isRowBottom(prefix, bibliographyId)) return

    const targetIndex: number = this.findIndexByPrefixAndBibliographyId(
      prefix,
      bibliographyId
    )

    this.items.splice(
      targetIndex,
      2,
      this.items[targetIndex + 1],
      this.items[targetIndex]
    )
  }

  // sortと併用する機会が無いのでそのままだが、v-forのindexの為並び替えを行うとindexとして機能しないので注意
  @Emit('selected')
  onClickRow(index: number): number {
    return index
  }
}
